<div class="container">
  <div *ngIf="!loading">
    <dashboard-info *ngIf="usuarioAdmin() && !showError"></dashboard-info>
    <viggo-core-error
      *ngIf="showError"
      [title]="errorObj.title"
      [noBackground]="true"
      [srcImg]="errorObj.srcImg"
      [classImg]="errorObj.classImg"
      [message]="errorObj.message"
    ></viggo-core-error>
  </div>
  <div class="app-loading" *ngIf="loading">
    <h4 class="text-splash">
      Carregando dados da empresa, por-favor aguarde!
    </h4>
    <div class="content-spinner">
      <svg class="spinner" viewBox="25 25 50 50">
        <circle
          class="path"
          cx="50"
          cy="50"
          r="20"
          fill="none"
          stroke-width="2"
          stroke-miterlimit="10"
        />
      </svg>
    </div>
  </div>
</div>
